import { createSlice } from '@reduxjs/toolkit';
import { verifyCode } from '../helpers/verifyCode';

const getInitialUser = () => {
  if (typeof window !== "undefined") {
    const storedUser = localStorage.getItem("user");
    try {
      return storedUser ? JSON.parse(storedUser) : null;
    } catch(error) {
      return null;
    }
  }
  return null;
};

const initialState = {
  selectedUserProfileImage: null,
  record: {
    email: null,
    password: null,
    token: null
  },
  mode: null, // 'create' | 'restore'
  verify: false,
  user: getInitialUser()
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    selectUserProfileImage: (state, action) => {
      state.selectedUserProfileImage = action.payload;
    },
    authRecord: (state, action) => {
      state.record = action.payload;
    },
    authMode: (state, action) => {
      state.mode = action.payload;
    },
    verify: (state, action) => {
      const { code, email } = action.payload;
      state.verify = verifyCode(code, email);
    },
    resetVerify: (state) => {
      state.verify = false;
    },
    login: (state, action) => {
      localStorage.setItem("user", JSON.stringify(action.payload));
      state.user = action.payload;
    },
    logout: (state) => {
      localStorage.removeItem("user");
      state.user = null;
    },
  },
});

export const { 
  selectUserProfileImage, 
  login, 
  logout, 
  authMode, 
  authRecord, 
  verify, 
  resetVerify 
} = authSlice.actions;

export default authSlice.reducer; 